var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHiddenDatabases(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-database-a",
    d: "M28.5,30 L1.5,30 C0.672,30 0,29.3295 0,28.5 L0,1.5 C0,0.672 0.672,0 1.5,0 L28.5,0 C29.3295,0 30,0.672 30,1.5 L30,28.5 C30,29.3295 29.3295,30 28.5,30 Z M3,27 L27,27 L27,3 L3,3 L3,27 Z M12,4.5 L12,10.5 L25.5,10.5 L25.5,4.5 L12,4.5 Z M4.5,25.5 L10.5,25.5 L10.5,19.5 L4.5,19.5 L4.5,25.5 Z M4.5,10.5 L10.5,10.5 L10.5,4.5 L4.5,4.5 L4.5,10.5 Z M4.5,18 L10.5,18 L10.5,12 L4.5,12 L4.5,18 Z M12,18 L25.5,18 L25.5,12 L12,12 L12,18 Z M12,25.5 L25.5,25.5 L25.5,19.5 L12,19.5 L12,25.5 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    x: 5,
    y: 6,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-database-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-database-a"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: -3,
    y: -3,
    fill: "#D3D3D3",
    mask: "url(#icon-database-b)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHiddenDatabases);
export default __webpack_public_path__ + "static/media/icon-hidden-databases.dcd4da74944ae92d865f03c89f63311e.svg";
export { ForwardRef as ReactComponent };